import React from 'react';
import SolutionsPage from '../components/SolutionsPage/SolutionsPage';

const Solutions: React.FC = () => <SolutionsPage />;

export default Solutions;
